import { render, staticRenderFns } from "./avatarCropper.vue?vue&type=template&id=061ec0d1&scoped=true"
import script from "./avatarCropper.vue?vue&type=script&lang=js"
export * from "./avatarCropper.vue?vue&type=script&lang=js"
import style0 from "./avatarCropper.vue?vue&type=style&index=0&id=061ec0d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061ec0d1",
  null
  
)

export default component.exports